import Base = require("./base-collection");

class Collection extends Base<{
    id: string;
    text: string;
    body: string;
}> {

    static about = `Markup meant to be rendered in tabs.  Used by [tabs](#app/controls/tabs).`;
}

export = Collection;